/* Page Intro Block JS File */
import ScrollMagic from 'ScrollMagic';
import 'animation.gsap';
import 'debug.addIndicators';
import TimelineMax from 'TimelineMax';
$(document).ready(function() {
	const scrollLineController = new ScrollMagic.Controller();
	const scrollLineScene = new ScrollMagic.Scene({
		triggerHook: "onEnter",
		duration: "100%"
	})
	.setTween(".phone-scroll .bluepart", {
		y: $(".phone-scroll").outerHeight()
	});
	scrollLineScene.addTo(scrollLineController);
});
